import { render, staticRenderFns } from "./AboutUsHeader.vue?vue&type=template&id=22dc4206&"
import script from "./AboutUsHeader.vue?vue&type=script&lang=js&"
export * from "./AboutUsHeader.vue?vue&type=script&lang=js&"
import style0 from "./AboutUsHeader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports